import { TransactionDetails } from "@merchant_api/models/transaction-details";

export class TransactionState {
    loading = false;
    error = null;
    record: TransactionDetails = {};
}
